<template>
  <nav class="bg-white/80 backdrop-blur-md border-b border-slate-200 shadow-sm sticky top-0 z-10">
    <div class="max-w-7xl mx-auto px-8 h-16 flex items-center justify-between gap-4">

      <!-- Left: back link or brand -->
      <div class="flex items-center gap-3 flex-1 min-w-0">
        <router-link
          v-if="back"
          to="/dashboard"
          class="flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-blue-600 transition-colors"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
          </svg>
          Dashboard
        </router-link>

        <div v-else class="flex items-center gap-2.5">
          <div class="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
            <svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.85 7h10.29l1.04 3H5.81l1.04-3zM19 17H5v-5h14v5z"/>
              <circle cx="7.5" cy="14.5" r="1.5"/>
              <circle cx="16.5" cy="14.5" r="1.5"/>
            </svg>
          </div>
          <div class="leading-tight">
            <p class="text-base font-bold text-slate-800">CabBook</p>
            <p class="text-xs text-slate-400 hidden sm:block">Booking Platform</p>
          </div>
        </div>
      </div>

      <!-- Center: page title -->
      <h1 v-if="back" class="text-base font-bold text-slate-700 flex-shrink-0">{{ title }}</h1>
      <div v-else></div>

      <!-- Right: logout -->
      <div class="flex items-center justify-end flex-1 min-w-0">
        <button
          v-if="showLogout"
          @click="logout"
          class="flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-red-600 hover:bg-red-50 px-3 py-2 rounded-xl transition-colors"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
          </svg>
          <span class="hidden sm:inline">Logout</span>
        </button>
        <div v-else></div>
      </div>

    </div>
  </nav>
</template>

<script>
export default {
  name: "AppNavbar",
  props: {
    title:      { type: String,  default: "" },
    back:       { type: Boolean, default: false },
    showLogout: { type: Boolean, default: false },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    },
  },
};
</script>
